/**
 *  Get an array filled with number between a range
 */
export function arrayRange(x: number, offset: number | null = null) {
  return offset ? [...Array(x).keys()].map(i => i + offset) : [...Array(x).keys()]
}
